import { schema } from "normalizr";

export const dealSchema = new schema.Entity("deal", {});
export const arrayOfDealSchemas = new schema.Array(dealSchema);

export const shortDealSchema = new schema.Entity("shortDeal", {});
export const arrayOfShortDealSchemas = new schema.Array(shortDealSchema);
